if (!customElements.get('giveaway-offer-buy-box')) {
  customElements.define(
    'giveaway-offer-buy-box',
    class GiveawayOfferBuyBox extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.spinner = this.querySelector('.giveaway-offer__spinner');
        this.errorEl = this.querySelector('[data-buy-box-error]');
        this.flavorValueEl = this.querySelector('[data-flavor-value]');

        this.form?.addEventListener('submit', this.onSubmit.bind(this));
        this.querySelectorAll('input[name="giveaway-offer-variant"]').forEach((input) => {
          input.addEventListener('change', this.onVariantChange.bind(this));
        });

        this.onVariantChange();
      }

      onVariantChange() {
        const selected = this.querySelector('input[name="giveaway-offer-variant"]:checked');
        if (!selected) return;

        if (this.flavorValueEl) {
          const label = selected.dataset.flavorLabel;
          if (label) this.flavorValueEl.textContent = label;
        }

        const pricing = this.closest('.giveaway-offer')?.querySelector('[data-offer-pricing]');
        if (!pricing) return;

        const priceEl = pricing.querySelector('[data-offer-price]');
        const compareEl = pricing.querySelector('[data-offer-compare-price]');
        const perBagEl = pricing.querySelector('[data-offer-per-bag-price]');
        const regEl = pricing.querySelector('[data-offer-reg-price]');

        if (priceEl) priceEl.textContent = selected.dataset.planTotal || '';
        if (perBagEl) perBagEl.textContent = selected.dataset.planUnit || '';
        if (regEl) regEl.textContent = selected.dataset.regUnit || '';

        if (compareEl) {
          const planTotal = selected.dataset.planTotal || '';
          const compareTotal = selected.dataset.compareTotal || '';
          const showCompare = compareTotal && compareTotal !== planTotal;
          compareEl.textContent = compareTotal;
          compareEl.hidden = !showCompare;
        }
      }

      setLoading(isLoading) {
        if (!this.submitButton) return;

        if (isLoading) {
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('loading');
          this.spinner?.classList.remove('hidden');
        } else {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.spinner?.classList.add('hidden');
        }
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = !message;
      }

      getCartAddUrl() {
        return (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      }

      getCartClearUrl() {
        return '/cart/clear.js';
      }

      buildItems() {
        const selected = this.querySelector('input[name="giveaway-offer-variant"]:checked');
        if (!selected) return null;

        const variantId = selected.value;
        const sellingPlan = selected.dataset.sellingPlanId;
        const quantity = parseInt(selected.dataset.quantity, 10) || 1;

        if (!variantId || !sellingPlan) return null;

        return [{ id: String(variantId), quantity, selling_plan: sellingPlan }];
      }

      async onSubmit(event) {
        event.preventDefault();
        this.showError('');

        const items = this.buildItems();
        if (!items) {
          this.showError('This offer is not configured yet.');
          return;
        }

        this.setLoading(true);

        try {
          await fetch(this.getCartClearUrl(), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
          });

          const response = await fetch(this.getCartAddUrl(), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ items }),
          });

          const data = await response.json();
          if (!response.ok || data.status) {
            const message = data.description || data.message || 'Could not start checkout.';
            this.showError(message);
            return;
          }

          window.location.href = '/checkout';
        } catch (error) {
          console.error('[giveaway-offer-buy-box]', error);
          this.showError('Network error. Please try again.');
        } finally {
          this.setLoading(false);
        }
      }
    }
  );
}
